import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"450px","height":"calc(100vh - 350px)"} }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = {
  class: "p-field-label",
  for: "switchboardname"
}
const _hoisted_8 = {
  for: "switchboardname",
  class: "fs-13 label-error"
}
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = {
  class: "p-field-label",
  for: "switchboardscs"
}
const _hoisted_11 = {
  for: "switchboardscs",
  class: "fs-13 label-error"
}
const _hoisted_12 = { class: "p-field mb-3" }
const _hoisted_13 = { class: "p-field-label my-4" }
const _hoisted_14 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_ctx.newSwitchboard && _ctx.newSwitchboard.switchboard)
    ? (_openBlock(), _createBlock(_component_Dialog, {
        key: 0,
        visible: _ctx.isDialogVisible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDialogVisible = $event)),
        onHide: _ctx.doHideDialog,
        modal: true,
        showHeader: false,
        closable: false,
        class: "dialog-custom"
      }, {
        default: _withCtx(() => [
          _createVNode("header", _hoisted_1, [
            _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.NameUpper")), 1),
                      _createVNode(_component_InputText, {
                        id: "switchboardname",
                        type: "text",
                        class: ["w-100", { 'input-error': !_ctx.isValidName }],
                        validator: '/^(?!\s).+(?<!\s)$',
                        modelValue: _ctx.newSwitchboard.switchboard.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newSwitchboard.switchboard.name = $event)),
                        maxlength: _ctx.nameMaxLength
                      }, null, 8, ["validator", "modelValue", "maxlength", "class"]),
                      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.invalidNameReason), 1)
                    ]),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.DeviceScsAddress")), 1),
                      _createVNode(_component_InputText, {
                        id: "switchboardscs",
                        type: "number",
                        class: ["w-100", { 'input-error': !_ctx.isValidScs }],
                        min: 0,
                        max: 15,
                        modelValue: _ctx.newSwitchboard.switchboard.scsAddr,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newSwitchboard.switchboard.scsAddr = $event))
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode("label", _hoisted_11, _toDisplayString(_ctx.invalidScsReason), 1)
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("SelectDevicesInGate")), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.devices, (option, i) => {
                        return (_openBlock(), _createBlock(_component_ListItemCheck, {
                          key: i,
                          modelValue: _ctx.switchboardDevicesIds,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchboardDevicesIds = $event)),
                          label: option.device.deviceName,
                          value: option.device.deviceId,
                          name: "device",
                          inputId: option.device.deviceId,
                          last: i === _ctx.devices.length - 1
                        }, null, 8, ["modelValue", "label", "value", "inputId", "last"]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("footer", _hoisted_14, [
            _createVNode(_component_Button, {
              class: "p-button-text mr-2",
              onClick: _ctx.handleHideDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              label: _ctx.buttonSubmitLabel,
              onClick: _ctx.handleButtonSubmitAction,
              class: "p-button-rounded p-button-raised p-button--m",
              disabled: _ctx.saveButtonDisabled
            }, null, 8, ["label", "onClick", "disabled"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "onHide"]))
    : _createCommentVNode("", true)
}